// extracted by mini-css-extract-plugin
module.exports = {"bb-social-media-side-share":"bb-social-media-side-share__0Pb5B"};